import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { QueryParams } from 'src/app/core/models/query-params.model';
import { SgrResponse } from 'src/app/core/models/response.model';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PerfilService {
  private url: string = environment.API;

  constructor(private httpClient: HttpClient, private authService: AuthService) {}

  atualizarPerfil(params: { body: string; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    const endpoint = this.url + '/perfil';
    const options = this.authService.setHttpOptions(params);
    return this.httpClient.put<SgrResponse>(endpoint, params.body, options);
  }

  salvarPreferencias(params: { body: string; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    const endpoint = this.url + '/perfil/preferencias';
    const options = this.authService.setHttpOptions(params);
    return this.httpClient.put<SgrResponse>(endpoint, params.body, options);
  }

  /** GET /perfil/preferencias — preferências persistidas no servidor (JWT). */
  buscarPreferencias(params?: { spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    const endpoint = this.url + '/perfil/preferencias';
    const options = this.authService.setHttpOptions(params || {});
    return this.httpClient.get<SgrResponse>(endpoint, options);
  }

  buscarHistoricoAndamentos(params?: { queryParams?: QueryParams; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    const endpoint = this.url + '/perfil/historico-andamentos';
    const options = this.authService.setHttpOptions(params || {});
    return this.httpClient.get<SgrResponse>(endpoint, options);
  }

  alterarSenha(params: { body: string; spinnerDelay?: number; spinnerOff?: boolean }): Observable<SgrResponse> {
    const endpoint = this.url + '/perfil/senha';
    const options = this.authService.setHttpOptions(params);
    return this.httpClient.post<SgrResponse>(endpoint, params.body, options);
  }
}
